/**
 * ShopFavoritesPage - Избранные товары (legacy)
 */

import React from "react";
import "simplebar-react/dist/simplebar.min.css";
import ShopFavoritesList from "../../components/shop/ShopFavoritesList";

const ShopFavoritesPage = () => {
    return (
        <main className="shop-main">
            <h2 className="shop-title">ИЗБРАННОЕ</h2>
            <ShopFavoritesList />
        </main>
    );
};

export default ShopFavoritesPage;
